export const VALIDATE_MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const VALIDATE_NO_JA_INPUT = /[^A-Z0-9-]/gi

export const VALIDATE_NUMBER = /^[0-9０-９]+$/
